<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("SERVICE.INFO") }}</h4>
    </div>
    <v-spacer />
    <div class="grid-body p-3 border-top-unset mb-3">
       <v-form ref="formInfo" lazy-validation >
      <div id="service-detail">
        <v-row>
          <v-col sm="10">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="mt-3">
              <v-tab-item>
                <label class="label-input">{{ $t("SERVICE.NAME") }} *</label>
                <v-text-field
                  v-model="editedItem.nameVi"
                  v-on:keyup="updateRoomTitle(editedItem.nameVi)"
                  :rules="ruleName"
                  outlined
                  dense
                  counter
                  maxlength="250"
                  class="input-counter"
                >
                </v-text-field>
                <p
                  v-if="required_nameVi && editedItem.nameVi == ''"
                  class="mt-2 text-danger"
                >
                  {{ $t("SERVICE.NAME") }} {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
                <label class="label-input mt-3">{{
                  $t("SERVICE.DESCRIPTION_INFO_DEFAULT")
                }}</label>
                <v-textarea
                  :rows="6"
                  v-model="editedItem.descriptionVi"
                  v-on:keyup="updateRoomDescription(editedItem.descriptionVi)"
                  outlined
                  :rules="ruleDescNotRequired"
                  dense
                  counter="3000"
                  maxlength="3000"
                  class="input-counter"
                >
                </v-textarea>
              </v-tab-item>
              <v-tab-item v-for="code in codeLangs" :key="code">
                <label class="label-input">{{ $t("SERVICE.NAME") }} *</label>
                <v-text-field
                  v-model="editedItem.serviceI18n.find(x => x.lang == code).name"
                  :rules="ruleName"
                  outlined
                  dense
                  counter
                  maxlength="250"
                  class="input-counter"
                >
                </v-text-field>
                <label class="label-input mt-3">{{
                  $t("SERVICE.DESCRIPTION_INFO")
                }}</label>
                <v-textarea
                  :rows="3"
                  v-model="
                    editedItem.serviceI18n.find(x => x.lang == code).description
                  "
                  outlined
                  :rules="ruleDescNotRequired"
                  counter="3000"
                  maxlength="3000"
                  class="input-counter"
                />
              </v-tab-item>
            </v-tabs-items>
            <p class="mb-0 mt-2" v-if="editedItem.chainCode">{{$t('CHAIN_CODE')}}: {{editedItem.chainCode}}</p>
            <div>
              <label class="label-input mt-3">{{ $t("SERVICE.CODE") }} *</label>
               <v-text-field
                  v-model="editedItem.serviceCode"
                  @change.native="checkServiceCodeExit"
                  :rules="ruleCode"
                  outlined
                  dense
                  :disabled="editedItem.id ? true : false"
                  counter
                  maxlength="20"
                  class="input-counter code"
                >
                </v-text-field>
                <div v-if="isServiceCodeExit"  class="v-messages theme--light error--text" role="alert">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">{{ $t("SERVICE.CODE") }} {{ $t("SERVICE.HAS_EXITS") }}</div>
                  </div>
                </div>
              <v-checkbox
                v-model="editedItem.status"
                :label="$t('ACTIVE')"
              ></v-checkbox>
              <div class="d-flex mandatory-add-on">
                <v-checkbox
                  v-model="editedItem.required"
                  :label="$t('SERVICE.MANDATORY_ADD_ON')"
                ></v-checkbox>
                <v-tooltip top nudge-right="130" content-class="custom-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <i class="icon-info fs-18 text-primary" v-bind="attrs" v-on="on"></i>
                  </template>
                  <span>{{ $t('SERVICE.MANDATORY_ADD_ON_INFO') }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
          <v-col sm="2">
            <p class="pl-3 m-0">{{ $t("IMAGE_SERVICE") }} *</p>
            <div class="d-flex">
              <div
                class="square"
                @mouseover="changeImageOverlay(true)"
                @mouseleave="changeImageOverlay(false)"
              >
                <img
                  v-if="!imagePreview"
                  src="@/assets/no-image.jpg"
                  class="square-content"
                />
                <img v-else :src="imagePreview" class="square-content" />
                <!-- <v-img v-if="imagePreview" :src="imagePreview" class="square-content" /> -->
                <v-overlay :absolute="true" :value="showImageOverlay">
                  <div class="d-flex">
                    <label
                      class="d-flex justify-center btn-icon label-upload"
                      for="input-file"
                    >
                      <v-icon color="#173d8f">mdi-upload</v-icon>
                    </label>
                    <input
                      class="d-none"
                      style="display: none"
                      type="file"
                      :value="fileUpload"
                      @change="changeImage($event)"
                      accept="image/*"
                      id="input-file"
                    />
                  </div>
                </v-overlay>
              </div>
            </div>
            <p v-if="isNoThumb" class="text-danger">
              {{ $t("SERVICE.NOTHUMB") }}
            </p>
            <p v-if="isImageLarge" class="text-danger">
              {{ $t("SERVICE.IMAGE_TOO_LARGE") }}
            </p>
          </v-col>
        </v-row>
        <v-divider />
        <!-- Thoi gian ap dung -->
        <label class="label-title">{{ $t("SERVICE.TIME_APPLY") }}</label>
        <v-row>
          <v-col>
            <p class="mt-2">{{ $t("SERVICE.DAY_APPLY") }}</p>
            <v-layout wrap>
              <!-- <v-checkbox
                class="mr-2 mt-0"
                color="indigo darken-3"
                v-for="date in dow"
                :label="date[sysLang]"
                :value="date.date"
                :key="date[sysLang]"
                v-model="weekend"
              >
              </v-checkbox> -->
              <v-chip-group v-model="weekend" column multiple active-class="primary">
                <v-chip v-for="date in dow" :value="date.date" class="chip-date">
                  {{date.text}}
                </v-chip>
              </v-chip-group>
            </v-layout>
          </v-col>
        </v-row>
        <v-row>
          <!-- Thoi gian dat -->
          <v-col cols="6">
            <p class="mb-0">{{ $t("SERVICE.TIME_BOOK") }}</p>
            <div class="mb-2">
              <v-radio-group row v-model="timeBookType" class="mt-0">
                <v-radio
                  class="pt-2"
                  color="indigo darken-3"
                  :label="$t('ALWAYS')"
                  :value="0"
                ></v-radio>
                <v-radio
                  class="pt-2"
                  color="indigo darken-3"
                  :label="$t('IN_PERIOD')"
                  :value="1"
                ></v-radio>
              </v-radio-group>
            </div>
            <v-row>
              <v-col sm="5" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.startBookingDate"
                  :min="currentDate"
                  :disabled="!timeBookType"
                />
                <p v-if="errorfromBook && timeBookType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
              <v-col sm="5" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.endBookingDate"
                  :min="editedItem.startBookingDate"
                  :disabled="!timeBookType"
                />
                <p v-if="errortoBook && timeBookType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <!-- Thoi gian su dung -->
          <v-col sm="6">
            <p class="mb-0">{{ $t("SERVICE.TIME_USE") }}</p>
            <div class="mb-2">
              <v-radio-group row v-model="timeUseType" class="mt-0">
                <v-radio
                  class="pt-2"
                  color="indigo darken-3"
                  :label="$t('ALWAYS')"
                  :value="0"
                ></v-radio>
                <v-radio
                  class="pt-2"
                  color="indigo darken-3"
                  :label="$t('IN_PERIOD')"
                  :value="1"
                ></v-radio>
              </v-radio-group>
            </div>
            <v-row>
              <v-col sm="5" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.startStayingDate"
                  :min="currentDate"
                  :disabled="!timeUseType"
                />
                <p v-if="errorfromStaying && timeUseType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
              <v-col sm="5" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.endStayingDate"
                  :min="editedItem.startStayingDate"
                  :disabled="!timeUseType"
                />
                <p v-if="errortoStaying && timeUseType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider />

        <!-- Ngay khong ap dung -->
        <!--  APPLY_FOR_STAYING: "Tính theo ngày ở",
    APPLY_FOR_BOOKING: "Tính theo ngày đặt", -->
        <label class="label-title">{{ $t("SERVICE.DAYS_NOT_APPLY") }}</label>
        <v-row>
          <v-col>
            <p class="m-0">{{ $t("APPLY_FOR_BOOKING") }}</p>
            <v-row class="day-not-applied">
              <v-col
                sm="6"
                class="pt-0"
                v-for="(range, i) in editedItem.serviceBlackoutsBooking"
                :key="i"
              >
                <v-row class="align-center">
                  <v-col sm="6" class="pb-0 pt-0">
                    <label>{{ $t("FROM_DATE") }}</label>
                    <date-picker
                      :model.sync="range.startBookingDate"
                      :min="currentDateLocal()"
                      class="outlined"
                    />
                  </v-col>
                  <v-col sm="5" class="pb-0 pt-0 pr-0">
                    <label>{{ $t("TO_DATE") }}</label>
                    <date-picker
                      :model.sync="range.endBookingDate"
                      :min="range.startBookingDate"
                    />
                  </v-col>
                  <v-col sm="1">
                    <v-icon
                      class="pt-4"
                      color="indigo"
                      @click="
                        removeDate(i)
                      "
                      >delete</v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="add-not-apply-date mt-3"
              @click="addnotApplyDates"
            >
              <v-icon color="#173d8f">add</v-icon>
              {{ $t("SERVICE.ADD_DAYS_NOT_APPLY") }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="m-0">{{ $t("APPLY_FOR_STAYING") }}</p>
            <v-row class="day-not-applied">
              <v-col
                sm="6"
                class="pt-0"
                v-for="(range, i) in editedItem.serviceBlackoutsStaying"
                :key="i"
              >
                <v-row class="align-center">
                  <v-col sm="6" class="pb-0 pt-0">
                    <label>{{ $t("FROM_DATE") }}</label>
                    <date-picker
                      :model.sync="range.startBookingDate"
                      :min="currentDateLocal()"
                      class="outlined"
                    />
                  </v-col>
                  <v-col sm="5" class="pb-0 pt-0 pr-0">
                    <label>{{ $t("TO_DATE") }}</label>
                    <date-picker
                      :model.sync="range.endBookingDate"
                      :min="range.startBookingDate"
                    />
                  </v-col>
                  <v-col sm="1">
                    <v-icon
                      class="pt-4"
                      color="indigo"
                      @click="
                        removeDateStay(i)
                      "
                      >delete</v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="add-not-apply-date mt-3"
              @click="addnotApplyDatesStay"
            >
              <v-icon color="#173d8f">add</v-icon>
              {{ $t("SERVICE.ADD_DAYS_NOT_APPLY") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider />
        <label class="label-title">{{ $t("SERVICE.PRICE") }}</label>
        <!-- Dich vu mien phi -->
        <v-row class="mt-0">
          <v-col>
            <v-radio-group row v-model="editedItem.free" class="mt-0">
              <v-radio
                color="indigo darken-3"
                :label="$t('SERVICE.FREE')"
                :value="true"
              ></v-radio>
              <v-radio
                color="indigo darken-3"
                :label="$t('SERVICE.PREMIUM')"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- Gia bao gom thue hay chua -->
        <v-row class="include-tax mt-0">
          <v-col>
            <v-checkbox
              v-model="editedItem.includedTax"
              :label="$t('SERVICE.INCLUDE_TAX')"
              class="pr-3"
            ></v-checkbox>
            <v-checkbox
              v-model="editedItem.bindingPrice"
              :label="$t('SERVICE.BINDING_PRICE')"
              class="pr-3"
            ></v-checkbox>
            <v-checkbox
              v-model="editedItem.oneTime"
              :label="$t('SERVICE.ONE_TIME')"
            ></v-checkbox>
          </v-col>
          <v-col md="4" class="text-right">
            <span>{{ $t("SERVICE.CURRENCY") }} : {{ usedCurrency }}</span>
          </v-col>
        </v-row>

        <!-- Gia theo ngay -->
        <div class="tbl-price">
          <table>
            <thead>
              <tr>
                <th>
                  <div class="header-wrapper vertical-divider text-center text-nowrap">
                    <span class="text-center">{{ $t("SERVICE.COPPY") }}</span>
                  </div>
                </th>
                <th
                  v-for="(item, index) in daysOfWeek"
                  :key="index"
                  :class="item.code"
                >
                  <div class="header-wrapper vertical-divider text-center">
                    <span class="text-center">{{ item.value }}</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="center">
                    <v-btn color="primary" @click="copyFirstValue(editedItem['priceMonday'])" class="mt-3 ml-3"
													:title="$t('COPY')" icon small><i
														class="icon-content_paste_go fs-16"></i></v-btn>
                </td>
                <td v-for="(date, index) in daysOfWeek" :key="index">
                  <div class="price-day" style="min-width: 150px">
                    <v-text-field 
                      :options="
                        currencyCode === 'VND'
                          ? priceOptionsVi
                          : priceOptionsEn
                      "
                      outlined
                      dense
                      :value="computedPrice(date).get()"
                      @input="handleInput($event, date.code)"
                      @keydown="keyCurrencyDown($event, currencyCode)"
                      v-bind:prefix="prefixCurrency"
                      v-bind:suffix="suffixCurrency"
                      :key="`${date.code}_${reloadKey}`"
                      :ref="`input_${date.code}`"
                    ></v-text-field>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <v-divider />
        <label class="label-title">{{ $t("SERVICE.SPECIAL_PRICE") }}</label>
        <!-- Gia dac biet -->
        <div>
          <template v-if="serviceSpecials">
            <div class="mt-0 d-flex flex-wrap">
              <div
                v-for="(item, index) in serviceSpecials"
                :key="index"
                class="pb-0 mr-4 mb-3"
              >
                <div class="mt-0 d-flex align-items-center">
                  <div  class="pb-0 mr-2">
                    <datePicker style="width: 150px;"
                      :ref="`datepicker${index}`"
                      @change="changeDateSpecials()"
                      :clearable="false"
                      v-model="item.appliedDate"
                      :disabled-date="item.disabledDateSpecials"
                      :popup-class="'popup-calendar-desktop-list'"
                      :lang="langDate"
                      :format="'DD/MM/YYYY'"
                      type="date"
                      :shortcuts="[]"
                      :range="false"
                      placeholder="Select date"
                    >
                    </datePicker>
                  </div>
                  <div  class="pl-0 pb-0">
                    <vuetify-number style="position: relative; top: -1.5px;"
                      :options="
                        currencyCode === 'VND'
                          ? priceOptionsVi
                          : priceOptionsEn
                      "
                      outlined="true"
                      dense
                      v-model="item.price"
                    ></vuetify-number>
                  </div>
                  <v-icon
                    color="error"
                    @click="removeSpecialDayPrice(item, index)"
                    >delete</v-icon
                  >
                </div>
              </div>
            </div>
          </template>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                @click="addServiceSpecials()"
                class="btn-popup-special-days-price"
                ><v-icon color="#173d8f">add</v-icon>
                {{ $t("SERVICE.SPECIAL_PRICE") }}</v-btn
              >
              <span class="special-service-desc"
                >* {{ $t("SERVICE.SPECIAL_DESC") }}</span
              >
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <!-- Don vi tinh -->
        <v-row class="mt-3">
          <v-col sm="4">
            <p class="mb-1">{{ $t("APPLY_FOR") }} *</p>
            <select-text
              class="pr-2"
              style="flex: 1"
              :items="unitOptions"
              :id.sync="editedItem.serviceType"
            />
          </v-col>
           <v-col sm="4">
            <p class="mb-1">{{ $t("SERVICE.UNIT") }} *</p>
            <select-text
              class="pr-2"
              style="flex: 1"
              :items="unit"
              :id.sync="editedItem.unitVi"
            />
          </v-col>
          <v-col sm="4">
            <p class="mb-1">{{ $t("SERVICE.TAX_LABEL") }} *</p>
            <multiSelect
              :options="taxOptions"
              :model.sync="taxSelected"
              class="disable-select-tax"
            />
          </v-col>
          <v-col sm="6">
            <p class="mb-1">{{ $t("SERVICE.MAXBOOK") }}</p>
            <input-text
              :notSmallThan="0"
              :isMoney="false"
              :regex="REGEX_NUMBER"
              :model.sync="editedItem.maxOrder"
            />
          </v-col>
          <v-col sm="6">
            <p class="mb-1">{{ $t("SERVICE.MAXQUATITY") }}</p>
            <v-row>
              <v-col class="pt-0 pb-0">
                <v-radio-group v-model="maxQuantity" class="mt-0" row>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('SERVICE.UNLIMIT')"
                    :value="-1"
                  ></v-radio>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('SERVICE.LIMIT')"
                    :value="1"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col v-if="maxQuantity === 1" class="pt-0 pb-0">
                <input-text
                  :notSmallThan="-1"
                  :isMoney="false"
                  :regex="REGEX_NUMBER"
                  :model.sync="editedItem.maxQuantity"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="btn-bottom">
          <v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
          <v-btn color="primary" class="pl-10 pr-10 btn-save" @click="save" :loading="loading">{{
            $t("SAVE")
          }}</v-btn>
        </div>
        <delete-dialog
          @deleteItem="deleteImage"
          :maxWidth="325"
          ref="deleteimage"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_PROMOTION_PACKAGE") }}?</span>
        </delete-dialog>
        <!-- {{ editedItem }} -->
      </div>
      </v-form>
    </div>
    <v-expansion-panels multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t("MORE_OPTIONS")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <label class="label-title">{{ $t("SERVICE.PACKAGE_SELL") }}</label>
            <v-row>
              <v-col>
                <v-radio-group v-model="editedItem.appliedFor" class="mt-0" row>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('SERVICE.PACKAGE_ALL')"
                    :value="0"
                  ></v-radio>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('SERVICE.PACKAGE_SPEC')"
                    :value="1"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              v-if="listOfRooms && editedItem.appliedFor !== 0"
              class="room-list mb-5"
            >
              <v-col
                md="6"
                class="child-no-margin py-0 pb-2"
                v-for="room in listOfRooms"
                :key="room.id"
              >
                <p class="m-0">
                  {{ room.roomTypeI18n.find(x => x.lang == defaultI18n).name }}
                </p>
                <div
                  class="pl-3"
                  v-for="(item, index) in room.ratePlans"
                  :key="index"
                >
                  <v-checkbox
                    v-for="(roomRates, index) in item.roomRates"
                    :key="index"
                    color="indigo darken-3"
                    :label="item.ratePlanI18n.find(x => x.lang == defaultI18n).name"
                    :value="roomRates.id"
                    class="mt-0"
                    v-model="editedItem.roomRateServices"
                  />
                </div>
              </v-col>
            </v-row>
            <v-divider />
            <label class="label-title">{{
              $t("_ROOM_SALE.SELL_MARKET")
            }}</label>
            <v-row>
              <v-col>
                <v-radio-group v-model="applyAllMarket" class="mt-0" row>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('_ROOM_SALE.SELL_MARKET_ALL')"
                    :value="'ALL'"
                    @change="applyAllMarketStatus()"
                  ></v-radio>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('_ROOM_SALE.SELL_MARKET_SPEC')"
                    :value="'NOT_ALL'"
                    @change="applyAllMarketStatus()"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="listOfMarkets && applyAllMarket !== 'ALL'">
              <v-col md="3" class="child-no-margin py-0">
                <v-checkbox
                  color="indigo darken-3"
                  :label="$t('SELECT_ALL')"
                  @change="clickSelectAllMarket()"
                  v-model="selectAllMarket"
                />
              </v-col>
              <v-col
                md="3"
                class="child-no-margin py-0"
                v-for="market in listOfMarkets"
                :key="market.id"
              >
                <v-checkbox
                  color="indigo darken-3"
                  :label="market.value"
                  :value="market.id"
                  v-model="editedItem.serviceMarkets"
                  @change="
                    editedItem.serviceMarkets.length == listOfMarkets.length
                      ? (selectAllMarket = true)
                      : (selectAllMarket = false)
                  "
                />
              </v-col>
            </v-row>
            <v-divider />
            <!-- <label class="label-title">{{
              $t("_ROOM_SALE.SELL_CHANNEL")
            }}</label> -->
            <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
        <label class="text-nowrap mr-2">{{
          $t("CHANNEL_APPLY")
        }}</label>
        <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
          v-model="selectedOTAGlobal" chips multiple style="width: 270px;" disabled>
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
              <span>{{ item.text }}</span>
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
            <!-- <v-row>
              <v-col>
                <v-radio-group v-model="applyAllChannel" class="mt-0" row>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('_ROOM_SALE.SELL_CHANNEL_ALL')"
                    :value="'ALL'"
                    @change="applyAllChannelStatus()"
                  ></v-radio>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('_ROOM_SALE.SELL_CHANNEL_SPEC')"
                    :value="'NOT_ALL'"
                    @change="applyAllChannelStatus()"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="listOfChannels && applyAllChannel !== 'ALL'">
              <v-col md="3" class="child-no-margin py-0">
                <v-checkbox
                  color="indigo darken-3"
                  :label="$t('SELECT_ALL')"
                  @change="clickSelectAllChannel"
                  v-model="selectAllChannel"
                />
              </v-col>
              <v-col
                md="3"
                class="child-no-margin py-0"
                v-for="channel in listOfChannels"
                :key="channel.id"
              >
                <v-checkbox
                  color="indigo darken-3"
                  :label="channel.value"
                  :value="channel.id"
                  v-model="editedItem.serviceChannels"
                  @change="
                    editedItem.serviceChannels.length == listOfChannels.length
                      ? (selectAllChannel = true)
                      : (selectAllChannel = false)
                  "
                />
              </v-col>
            </v-row> -->
            <v-divider />
            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">{{
                $t("BACK")
              }}</v-btn>
              <v-btn
                color="primary"
                class="pl-10 pr-10 btn-save"
                @click="save" :loading="loading"
                >{{ $t("SAVE") }}</v-btn
              >
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import DatePickerCustom from "@/components/Utils/DatePicker.vue";
import MultiSelect from "@/components/Utils/MultiSelect.vue";
import { VueEditor } from "vue2-editor";
//import Multiselect from "vue-multiselect";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { servicePackageService } from "@/_services/Service/service.service.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import moment, { max } from "moment";
import VueNumeric from "vue-numeric";

import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { DAYS_OF_WEEK } from "@/_helpers/config.js";

import {
  _validateFormI18n,
  _alert,
  _resetErrorState
} from "@/_helpers/function.js";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { REGEX_SERVICE_CODE } from "@/_helpers/constant.js";
import {
  MAX_CHILD_QUANTITY,
  MAX_ADULTS_QUANTITY,
  MEALS,
  SPD_ERROR
} from "@/_helpers/config.js";
import Textarea from "@/components/Utils/Textarea.vue";
//
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

//
export default {
  components: {
    //Multiselect,
    datePicker: DatePicker,
    "date-picker": DatePickerCustom,
    "input-text": Input,
    "select-text": Select,
    multiSelect: MultiSelect,
    VueEditor,
    "input-textarea": Textarea,
    "delete-dialog": DeleteDialog,
    DateRangePicker,
    VueNumeric,
  },
  created() {
    this.currencyCode = this.priceOptionsVi.suffix;
    this.initialize();
  },
  data() {
    return {
      required_name: false,
      required_code: false,
      required_code_length: false,
      required_code_exits: false,
      required_nameVi: false,
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      editedItem: {
        status: true,
        appliedFor: 0,
        bitWeekDays: 127,
        serviceChannels: [],
        serviceCode: "",
        free: false,
        startBookingDate: null,
        startStayingDate: null,
        defaultImageId: "",
        includedTax: true,
        maxOrder: 1,
        // notApplyDates: [],
        serviceBlackoutsBooking: [],
        serviceBlackoutsStaying: [],
        roomRateServices: [],
        priceFriday: "",
        priceMonday: "",
        priceSaturday: "",
        priceSunday: "",
        priceThursday: "",
        priceTuesday: "",
        priceWednesday: "",
        serviceType: 0,
        serviceSpecials: [],
        endBookingDate: null,
        endStayingDate: null,
        bindingPrice: false,
        serviceI18n: [
          { description: "", lang: "vi", name: "" },
          { description: "", lang: "en", name: "" },
          { description: "", lang: "ja", name: "" },
          { description: "", lang: "zh", name: "" },
          { description: "", lang: "ko", name: "" }
        ],
        stayingSession: 0,
        belongTo: 0,
        maxQuantity: -1,
        oneTime: false,
        uneditable: 1,
        nameVi: "",
        unitVi: "",
        descriptionVi: "",
        required: false,
      },
      dow: DAYS_OF_WEEK,
      weekend: [],
      defaultWeekend: [],
      dayApplyInWeekOptions: [
        { id: 1, value: 1, text: `${this.$t("SUNDAY")}` },
        { id: 2, value: 2, text: `${this.$t("MONDAY")}` },
        { id: 3, value: 3, text: `${this.$t("TUESDAY")}` },
        { id: 4, value: 4, text: `${this.$t("WEDNESDAY")}` },
        { id: 5, value: 5, text: `${this.$t("THURSDAY")}` },
        { id: 6, value: 6, text: `${this.$t("FRIDAY")}` },
        { id: 7, value: 7, text: `${this.$t("SATURDAY")}` }
      ],
      taxSelected: [1],
      taxOptions: [
        { id: 1, value: 1, text: `${this.$t("SERVICE.TAX_DEFAULT")}` }
      ],
      timeBookType: 0,
      timeUseType: 0,
      unitOptions: [
        { id: 0, value: `${this.$t("SERVICE.PER_BOOKING")}` },
        { id: 1, value: `${this.$t("SERVICE.PER_PERSON_PER_NIGHT")}` },
        { id: 2, value: `${this.$t("SERVICE.PER_ROOM")}` },
        { id: 3, value: `${this.$t("SERVICE.PER_ROOM_PER_NIGHT")}` },
        { id: 4, value: `${this.$t("SERVICE.PER_PERSON")}` }
      ],
      // tmp: null,
      listOfRooms: [],
      listOfChannels: [
        { id: 1, name: "Booking Engine" }
        // { id: 2, name: 'OneInventory'},
      ],
      daysOfWeek: [
        
        { code: "priceMonday", value: this.$t("MONDAY") },
        { code: "priceTuesday", value: this.$t("TUESDAY") },
        { code: "priceWednesday", value: this.$t("WEDNESDAY") },
        { code: "priceThursday", value: this.$t("THURSDAY") },
        { code: "priceFriday", value: this.$t("FRIDAY") },
        { code: "priceSaturday", value: this.$t("SATURDAY") },
        { code: "priceSunday", value: this.$t("SUNDAY") }
      ],
      showImageOverlay: false,
      fileUpload: "",
      imagePreview: "",
      isNoThumb: false,
      currencyCode: JSON.parse(localStorage.getItem("currency")),
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      isServiceCodeExit: false,
      notApplyDates: [],
      notApplyDatesStay: [],
      specialDaysPrice: [],
      selectAllPlans: false,
      imageFormData: "",
      errors: SPD_ERROR,
      dialog: false,
      originalSpecialDaysPrice: [],
      errorApiSpecialService: false,
      errorfromBook: false,
      errortoBook: false,
      errorfromStaying: false,
      errortoStaying: false,
      errorname_vi: false,
      errorname_en: false,
      isImageLarge: false,
      //

      listOfChannels: [],
      selectAllChannel: false,
      listOfMarkets: [],
      selectAllMarket: false,
      applyAllChannel: "ALL",
      applyAllMarket: "ALL",
      maxQuantity: -1,
      isEmptyDefaultTitle: false,
      serviceSpecials: [],
      unit: [],
       currentDatePicker: moment()
        .startOf("day")
        .format("YYYY-MM-DD"),
        loading: false,
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
      timeout: null,
      reloadKey: 0,
    };
  },
  computed: {
    computedPrice() {
      return (date) => ({
        get: () => {
          return this.convertDecimalViaLocal(this.editedItem[date.code]) || "";
        },
        set: (value) => {
          this.$set(this.editedItem, date.code, value);
        }
      });
    },
    yesterday() {
      var d = new Date();
      return d.setDate(d.getDate() - 1);
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_SERVICE_CODE() {
      return REGEX_SERVICE_CODE;
    },
    likesAllPromotionParties() {
      return (
        this.editedItem.promotionParties.length === this.promotionParties.length
      );
    },
    iconObject() {
      if (this.likesAllPromotionParties) return "mdi-close-box";
      if (this.likesSomePromotionParties) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    langDate() {
      return {
        formatLocale: {
          months: [
            `${this.$t("TH1")}`,
            `${this.$t("TH2")}`,
            `${this.$t("TH3")}`,
            `${this.$t("TH4")}`,
            `${this.$t("TH5")}`,
            `${this.$t("TH6")}`,
            `${this.$t("TH7")}`,
            `${this.$t("TH8")}`,
            `${this.$t("TH9")}`,
            `${this.$t("TH10")}`,
            `${this.$t("TH11")}`,
            `${this.$t("TH12")}`
          ],
          // MMM
          monthsShort: [
            `${this.$t("TH1")}`,
            `${this.$t("TH2")}`,
            `${this.$t("TH3")}`,
            `${this.$t("TH4")}`,
            `${this.$t("TH5")}`,
            `${this.$t("TH6")}`,
            `${this.$t("TH7")}`,
            `${this.$t("TH8")}`,
            `${this.$t("TH9")}`,
            `${this.$t("TH10")}`,
            `${this.$t("TH11")}`,
            `${this.$t("TH12")}`
          ],
          // dddd
          weekdays: [
            `${this.$t("T8")}`,
            `${this.$t("T2")}`,
            `${this.$t("T3")}`,
            `${this.$t("T4")}`,
            `${this.$t("T5")}`,
            `${this.$t("T6")}`,
            `${this.$t("T7")}`
          ],
          // ddd
          weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          // dd
          weekdaysMin: [
            `${this.$t("T8")}`,
            `${this.$t("T2")}`,
            `${this.$t("T3")}`,
            `${this.$t("T4")}`,
            `${this.$t("T5")}`,
            `${this.$t("T6")}`,
            `${this.$t("T7")}`
          ],
          // first day of week
          firstDayOfWeek: 1
        },
        monthBeforeYear: false
      };
    }
  },
  watch: {
    maxQuantity() {
      if (this.maxQuantity === -1) {
        this.editedItem.maxQuantity = -1;
      } else if (this.editedItem.maxQuantity === -1) {
        this.editedItem.maxQuantity = 1;
      }
    },
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.serviceI18n.find(
        x => x.lang == value
      ).description;
    },
    dayApplyInWeekSelected() {
      // let tmp_applyDay = [0,0,0,0,0,0,0];
      // this.dayApplyInWeekSelected.forEach(function(value) {
      //   tmp_applyDay[value-1] = 1;
      // });
      // this.editedItem.applyDay = tmp_applyDay.toString().replace(/,/g, '');
      // this.daysOfWeek.forEach((element, index) => {
      //   if (this.editedItem.applyDay.charAt(index) === '0'){
      //     this.editedItem[element.code] = 0;
      //   }
      // });
    },
    timeBookType() {
      this.editedItem.bookingSession = this.timeBookType;
      if (this.timeBookType == 0) {
        this.editedItem.startBookingDate = null;
        this.editedItem.endBookingDate = null;
        // alert('dsfs');
      } else {
      }
    },
    timeUseType() {
      this.editedItem.stayingSession = this.timeUseType;
      if (this.timeUseType == 0) {
        this.editedItem.startStayingDate = null;
        this.editedItem.endStayingDate = null;
        // alert('dsfs');
      } else {
      }
    },
    weekend(value) {
      let tmp = [0, 0, 0, 0, 0, 0, 0];
      value.forEach(function(element) {
        if (element === "MON") {
          tmp[0] = 1;
        }

        if (element === "TUE") {
          tmp[1] = 1;
        }

        if (element === "WED") {
          tmp[2] = 1;
        }

        if (element === "THU") {
          tmp[3] = 1;
        }

        if (element === "FRI") {
          tmp[4] = 1;
        }

        if (element === "SAT") {
          tmp[5] = 1;
        }

        if (element === "SUN") {
          tmp[6] = 1;
        }
      });

      this.editedItem.bitWeekDays = parseInt(tmp.join(""), 2);
    },
    editedItem: {
      handler(value) {
        if (value.serviceSpecials) {
          const arrDate = [];
          value.serviceSpecials.forEach(element => {
            element.appliedDate = new Date(element.appliedDate);
            arrDate.push(new Date(element.appliedDate).setHours(0, 0, 0, 0));
          });
          this.serviceSpecials = value.serviceSpecials.map(item =>
            Object.assign({}, item, {
              disabledDateSpecials: function(date) {
                const startDate = new Date();
                const appliedDate = item.appliedDate;
                startDate.setHours(0, 0, 0, 0);
                return (
                  arrDate
                    .filter(
                      i => i !== new Date(appliedDate).setHours(0, 0, 0, 0)
                    )
                    .includes(new Date(date).setHours(0, 0, 0, 0)) ||
                  date < startDate
                );
              }
            })
          );
        }
      }
    }
  },
  mounted() {},
  methods: {
    handleInput(value, code) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const newVal = this.setCurrency(value);
        this.computedPrice({ code }).set(newVal);
        this.reloadKey += 1;
        this.$nextTick(() => {
          const inputRef = this.$refs[`input_${code}`];
          if (inputRef && inputRef[0]) {
            inputRef[0].focus();
          }
        });
      }, this.timeOutChange(value));
    },
    _moment: moment,
     currentDateLocal() {
      let today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //As January is 0.
      var yyyy = today.getFullYear();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      return yyyy + "-" + mm + "-" + dd;
    },
    changeDateSpecials() {
      // this.editedItem.serviceSpecials = [...this.serviceSpecials];
      const arrDate = [];
      this.serviceSpecials.forEach(element => {
        element.appliedDate = new Date(element.appliedDate);
        arrDate.push(new Date(element.appliedDate).setHours(0, 0, 0, 0));
      });
      this.serviceSpecials.forEach(
        item =>
          (item.disabledDateSpecials = function(date) {
            const startDate = new Date();
            const appliedDate = item.appliedDate;
            startDate.setHours(0, 0, 0, 0);
            return (
              arrDate
                .filter(i => i !== new Date(appliedDate).setHours(0, 0, 0, 0))
                .includes(new Date(date).setHours(0, 0, 0, 0)) ||
              date < startDate
            );
          })
      );
    },
    removeSpecialDayPrice(item, index) {
      this.serviceSpecials.splice(index, 1);
      this.changeDateSpecials();
    },
    addServiceSpecials() {
      if (this.serviceSpecials.length === 0) {
        this.serviceSpecials.push({
          appliedDate: new Date(),
          price: 0,
          disabledDateSpecials: null
        });
      } else {
        const arrSort = this.serviceSpecials.sort(function(a, b) {
          a = new Date(a.appliedDate).getTime();
          b = new Date(b.appliedDate).getTime();
          return a > b ? 1 : a < b ? -1 : 0;
        });
        const tomorrow = arrSort[arrSort.length - 1].appliedDate
          ? new Date(arrSort[arrSort.length - 1].appliedDate)
          : new Date();

        // Cộng thêm 1 ngày
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.serviceSpecials.push({
          appliedDate: tomorrow,
          price: 0,
          disabledDateSpecials: null
        });
      }
      this.changeDateSpecials();
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.serviceI18n.length; i++) {
          this.editedItem.serviceI18n[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.editedItem.serviceI18n.length; i++) {
        this.editedItem.serviceI18n[i].description = value;
      }
    },
    async initialize() {
      _resetErrorState(this.errors);
      await servicePackageService.getUnit().then(res => {
        this.unit = res.data.map(x => {
          return {
            id: x.lookupItemCode,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
      });
      //
      await salePackageService.getApplyForObject().then(res => {
        this.promotionParties = res.data.map(x => {
          return {
            value: x.id,
            text: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.promotionParties = this.promotionParties.filter(x => x.value);
      });

      await service.getChannel().then(res => {
        this.listOfChannels = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.listOfChannels = this.listOfChannels.filter(x => x.value);
      });

      await service.getMarket().then(res => {
        this.listOfMarkets = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.listOfMarkets = this.listOfMarkets.filter(x => x.value);
      });
      //
      let id = this.$route.params.id;
      if (id != 0) {
        servicePackageService.getDetailService(id).then(res => {
          this.editedItem = res.data;
          if (this.editedItem.serviceMarkets == null) {
            this.applyAllMarket = "ALL";
          } else {
            this.applyAllMarket = "NOT_ALL";
            if (
              this.editedItem.serviceMarkets.length == this.listOfMarkets.length
            ) {
              this.selectAllMarket = true;
            } else {
              this.selectAllMarket = false;
            }
          }
          if (this.editedItem.serviceChannels == null) {
            this.applyAllChannel = "ALL";
          } else {
            this.applyAllChannel = "NOT_ALL";
            if (res.data.serviceChannels.length == this.listOfChannels.length) {
              this.selectAllChannel = true;
            } else {
              this.selectAllChannel = false;
            }
          }
          if (this.editedItem.maxQuantity === -1) {
            this.maxQuantity = -1;
          } else {
            this.maxQuantity = 1;
          }
          this.imagePreview = this.editedItem.imageUrl;

          // Chuyển từ binary sang select
          this.defaultWeekend = this.convertFromBinaryToListSelection(
            res.data.bitWeekDays
          );
          var tmp = [];
          this.defaultWeekend.forEach(function(element, index) {
            if (element == 1) {
              if (index == 0) {
                tmp.push("MON");
              }
              if (index == 1) {
                tmp.push("TUE");
              }
              if (index == 2) {
                tmp.push("WED");
              }
              if (index == 3) {
                tmp.push("THU");
              }
              if (index == 4) {
                tmp.push("FRI");
              }
              if (index == 5) {
                tmp.push("SAT");
              }
              if (index == 6) {
                tmp.push("SUN");
              }
            }
          });
          this.weekend = tmp;

          // Neu ton tai khoang thoi gian su dung
          if (
            this.editedItem.startStayingDate &&
            this.editedItem.endStayingDate
          ) {
            this.timeUseType = 1;
            this.editedItem.startStayingDate = moment(
              this.editedItem.startStayingDate
            ).format("YYYY-MM-DD");
            this.editedItem.endStayingDate = moment(
              this.editedItem.endStayingDate
            ).format("YYYY-MM-DD");
          }

          // Neu ton tai khoang thoi gian dat
          if (
            this.editedItem.startBookingDate &&
            this.editedItem.endBookingDate
          ) {
            this.timeBookType = 1;
            this.editedItem.startBookingDate = moment(
              this.editedItem.startBookingDate
            ).format("YYYY-MM-DD");
            this.editedItem.endBookingDate = moment(
              this.editedItem.endBookingDate
            ).format("YYYY-MM-DD");
          }

          this.editedItem.serviceSpecials.forEach(x => {
            let date_from = new Date(x.startDate);
            let date_to = new Date(x.endDate);

            // let appliedDate = new Date(x.appliedDate);
            this.originalSpecialDaysPrice.push({
              date: { startDate: date_from, endDate: date_to },
              price: x.price,
              error_time: false,
              error_price: false
            });
            this.specialDaysPrice.push({
              date: { startDate: date_from, endDate: date_to },
              price: x.price,
              error_time: false,
              error_price: false
            });
          });
        });
      } else {
        this.editedItem = {
          status: true,
          appliedFor: 0,
          bitWeekDays: 127,
          serviceChannels: [],
          serviceCode: "",
          free: false,
          startBookingDate: null,
          startStayingDate: null,
          defaultImageId: "",
          includedTax: true,
          maxOrder: 1,
          // notApplyDates: [],
          serviceBlackoutsBooking: [],
          serviceBlackoutsStaying: [],
          roomRateServices: [],
          priceFriday: "",
          priceMonday: "",
          priceSaturday: "",
          priceSunday: "",
          priceThursday: "",
          priceTuesday: "",
          priceWednesday: "",
          serviceType: 0,
          serviceSpecials: [],
          endBookingDate: null,
          endStayingDate: null,
          bindingPrice: false,
          serviceI18n: [],
          stayingSession: 0,
          belongTo: 0,
          maxQuantity: -1,
          oneTime: false,
          uneditable: 1,
          nameVi: "",
          unitVi: "",
          descriptionVi: "",
          required: false
        };
        this.codeLangs.forEach(e => {
          this.editedItem.serviceI18n.push({
            description: "", 
            lang: e, 
            name: ""
          })
        });

        // Chuyển từ binary sang select
        this.defaultWeekend = this.convertFromBinaryToListSelection(
          this.editedItem.bitWeekDays
        );
        var tmp = [];
        this.defaultWeekend.forEach(function(element, index) {
          if (element == 1) {
            if (index == 0) {
              tmp.push("MON");
            }
            if (index == 1) {
              tmp.push("TUE");
            }
            if (index == 2) {
              tmp.push("WED");
            }
            if (index == 3) {
              tmp.push("THU");
            }
            if (index == 4) {
              tmp.push("FRI");
            }
            if (index == 5) {
              tmp.push("SAT");
            }
            if (index == 6) {
              tmp.push("SUN");
            }
          }
        });
        this.weekend = tmp;
      }

      // Dong bo tich chon cac phong
      this.roomTyleApplied = this.editedItem.plans;
      let body = {};
      body.keyword = null;
      body.status = null;
      body.limit = 1000;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;
      salePackageService.getRoomRate("EZ_BE").then(res => {
        if (res.responseCode == 0) {
          this.listOfRooms = res.data;
          this.listOfRooms = this.listOfRooms.filter(e => e.ratePlans.length > 0);
        }
      });
    },
    checkServiceCodeExit() {
      if (this.editedItem.serviceCode.length < 2) {
        this.required_code_length = true;
      } else {
        this.required_code_length = false;
        servicePackageService
          .checkServiceCode(this.editedItem.serviceCode.toUpperCase())
          .then(res => {
            if (res.responseCode == 1) {
              this.isServiceCodeExit = true;
              this.required_code_exits = true;
            } else {
              this.isServiceCodeExit = false;
              this.required_code_exits = false;
            }
          });
      }
    },
    validateAndFocusTab() {
        if (!this.editedItem.nameVi) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.editedItem.serviceI18n.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async save() {
      await this.validateAndFocusTab()
      await this.$nextTick();
      let form_validate = this.$refs.formInfo.validate();
      
      if (!form_validate) {
          this.$store.commit("alert/display", {
              message: this.$t("_VALIDATE.REQUIRED"),
              error: true,
              success: false,
          });
          const el = document.querySelector(".v-messages.error--text:first-of-type");
          el.scrollIntoView();
          this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
          });
          return false;
      }
      if (!this.$refs.formInfo.validate()) return false;
      this.required_name = false;
      this.required_nameVi = false;
      if (!this.editedItem.nameVi) {
        this.required_nameVi = true;
      }
      // this.required_code = false;
      let element = document.querySelector(".btn-save");
      this.editedItem.serviceI18n.forEach(e => {
        if (e.name == "") {
          this.required_name = true;
          if (e.lang == "vi") {
            this.errorname_vi = true;
          } else if (e.lang == "en") {
            this.errorname_en = true;
          }
        } else {
          this.errorname_en = false;
          this.errorname_vi = false;
        }
      });
      if (!this.errorname_vi && this.errorname_en) {
        this.tab = 1;
      } else {
        this.tab = 0;
      }
      if (this.editedItem.serviceCode.length < 2) {
        this.required_code_length = true;
      }

      if (this.editedItem.startBookingDate == null && this.timeBookType == 1) {
        this.errorfromBook = true;
      } else {
        this.errorfromBook = false;
      }

      if (this.editedItem.endBookingDate == null && this.timeBookType == 1) {
        this.errortoBook = true;
      } else {
        this.errortoBook = false;
      }

      if (this.editedItem.startStayingDate == null && this.timeUseType == 1) {
        this.errorfromStaying = true;
      } else {
        this.errorfromStaying = false;
      }

      if (this.editedItem.endStayingDate == null && this.timeUseType == 1) {
        this.errortoStaying = true;
      } else {
        this.errortoStaying = false;
      }

      if (
        !this.editedItem.defaultImageThumbUrl ||
        !this.editedItem.defaultImageId
      ) {
        this.isNoThumb = true;
      }
      this.editedItem.serviceSpecials = this.serviceSpecials.map(item =>
        Object.assign(
          {},
          {
            appliedDate: moment(item.appliedDate).format("YYYY-MM-DD"),
            price: item.price
          }
        )
      );

      if (
        !this.isNoThumb &&
        !this.required_name &&
        !this.required_code_exits &&
        !this.required_code_length &&
        !this.errortoStaying &&
        !this.errorfromStaying &&
        !this.errorfromBook &&
        !this.errortoBook &&
        !this.required_nameVi
      ) {
        this.isImageLarge = false;
        this.loading = true;
        if (this.editedItem.id) {
          let tmp = Object.assign({}, this.editedItem);
          delete tmp.defaultImageThumbUrl;

          await servicePackageService.updateService(tmp).then(res => {
            _alert(res, this.$t(res.data), true);
            if (res.responseCode != 0) {
              element.disabled = false;
            }
            this.loading = false;
          });
        } else {
           this.editedItem.serviceCode = this.editedItem.serviceCode.toUpperCase();
          let tmp = Object.assign({}, this.editedItem);
          delete tmp.defaultImageThumbUrl;
          await servicePackageService.createService(tmp).then(res => {
            _alert(res, this.$t(res.data), false);
            this.$router.back();
            if (res.responseCode != 0) {
              element.disabled = false;
            }
          });
          this.loading = false;
        }
      } else {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false
        });
      }
    },
    back() {
      this.$router.back();
    },
    addnotApplyDates() {
      if (this.editedItem.serviceBlackoutsBooking.length > 0) {
        let prevPeriod = this.editedItem.serviceBlackoutsBooking[
          this.editedItem.serviceBlackoutsBooking.length - 1
        ];
        let from = this._moment(prevPeriod.endBookingDate)
          .add(1, "day")
          .format("YYYY-MM-DD");
        let to = this._moment(prevPeriod.endBookingDate)
          .add(2, "day")
          .format("YYYY-MM-DD");
        this.editedItem.serviceBlackoutsBooking.push({
          startBookingDate: from,
          endBookingDate: to
        });
      } else {
        this.editedItem.serviceBlackoutsBooking.push({
          startBookingDate: this._moment(this.currentDatePicker)
            .add(4, "day")
            .format("YYYY-MM-DD"),
          endBookingDate: this._moment(this.currentDatePicker)
            .add(5, "day")
            .format("YYYY-MM-DD")
        });
      }
    },
     addnotApplyDatesStay() {
      if (this.editedItem.serviceBlackoutsStaying.length > 0) {
        let prevPeriod = this.editedItem.serviceBlackoutsStaying[
          this.editedItem.serviceBlackoutsStaying.length - 1
        ];
        let from = this._moment(prevPeriod.endBookingDate)
          .add(1, "day")
          .format("YYYY-MM-DD");
        let to = this._moment(prevPeriod.endBookingDate)
          .add(2, "day")
          .format("YYYY-MM-DD");
        this.editedItem.serviceBlackoutsStaying.push({
          startBookingDate: from,
          endBookingDate: to
        });
      } else {
        this.editedItem.serviceBlackoutsStaying.push({
          startBookingDate: this._moment(this.currentDatePicker)
            .add(4, "day")
            .format("YYYY-MM-DD"),
          endBookingDate: this._moment(this.currentDatePicker)
            .add(5, "day")
            .format("YYYY-MM-DD")
        });
      }
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    removeDate(index) {
      this.editedItem.serviceBlackoutsBooking.splice(index, 1);
      // this.updateDate();
    },
    removeDateStay(index) {
      this.editedItem.serviceBlackoutsStaying.splice(index, 1);
      // this.updateDateStay();
    },
    addSpecialDaysPrice() {
      if (this.specialDaysPrice.length === 0) {
        this.specialDaysPrice.push({
          date: {
            startDate: this.currentDate,
            endDate: new Date(moment(this.currentDate).add(1, "d"))
          },
          price: null,
          error_time: false,
          error_price: false
        });
      } else {
        this.specialDaysPrice.push({
          date: {
            startDate: new Date(
              moment(
                this.specialDaysPrice[this.specialDaysPrice.length - 1].date
                  .endDate
              ).add(1, "d")
            ),
            endDate: new Date(
              moment(
                this.specialDaysPrice[this.specialDaysPrice.length - 1].date
                  .endDate
              ).add(2, "d")
            )
          },
          price: null,
          error_time: false,
          error_price: false
        });
      }
    },
    saveSpecialDaysPrice() {
      let error = false;
      this.specialDaysPrice.forEach((item, index) => {
        if (item.price == null) {
          this.specialDaysPrice[index].error_price = true;
          error = true;
        }
        if (item.date.startDate == null || item.date.endDate == null) {
          this.specialDaysPrice[index].error_time = true;
          error = true;
        }
      });

      if (!error) {
        let tmp_array = [];
        this.specialDaysPrice.forEach(e => {
          tmp_array.push({
            startDate: moment(e.date.startDate).format("YYYY-MM-DD"),
            endDate: moment(e.date.endDate).format("YYYY-MM-DD"),
            price: e.price
          });
        });
        servicePackageService.checkSpecialDaysPrice(tmp_array).then(res => {
          if (res.responseCode == 0) {
            this.editedItem.serviceSpecials = tmp_array;
            this.$refs["popup-special-days-price"].hide();
            this.errorApiSpecialService = false;
          } else {
            this.errorApiSpecialService = true;
          }
        });
      }
    },
    cancelSpecialDaysPrice() {
      let tmp_array = [];
      this.specialDaysPrice = [];
      this.originalSpecialDaysPrice.forEach(e => {
        tmp_array.push({
          startDate: moment(e.date.startDate).format("YYYY-MM-DD"),
          endDate: moment(e.date.endDate).format("YYYY-MM-DD"),
          price: e.price
        });
        this.specialDaysPrice.push({
          date: {
            startDate: e.date.startDate,
            endDate: e.date.endDate
          },
          price: e.price,
          error_time: false,
          error_price: false
        });
      });

      this.editedItem.serviceSpecials = tmp_array;
      this.$refs["popup-special-days-price"].hide();
      this.errorApiSpecialService = false;
    },
    changeImageOverlay(visible) {
      this.showImageOverlay = visible;
    },
    changeImage(input) {
      const formData = new FormData();
      formData.append("file", input.target.files[0]);
      // console.log(input.target);

      this.imageFormData = formData;
      if (input.target.files[0].size < 8388608) {
        this.isImageLarge = false;
        servicePackageService.uploadImage(formData).then(res => {
          if (res.responseCode === 0) {
            this.editedItem.defaultImageThumbUrl = res.data.img;
            this.editedItem.defaultImageId = res.data.id;
            this.imagePreview = res.data.img;
            if (this.isNoThumb) {
              this.isNoThumb = false;
            }
            _alert(res, this.$t("SERVICE.UPDATE_IMAGE_SUCCESS"), false);
          } else {
            _alert(res, this.$t("SERVICE.UPDATE_IMAGE_FAIL"), false);
            if (!this.editedItem.defaultImageThumbUrl) {
              this.isNoThumb = true;
            }
          }
        });
      } else {
        this.isImageLarge = true;
      }
    },
    deleteImage() {
      servicePackageService
        .removeImage(this.editedItem.defaultImageId)
        .then(res => {
          _alert(res, this.$t(res.data), false);
        });
    },
    copyFirstValue(value) {
      this.daysOfWeek.forEach(e => {
        this.editedItem[e.code] = value;
      });
    },
    clickSelectAllPlans() {
      if (this.selectAllPlans) {
        this.listOfRooms.forEach(e => {
          this.editedItem.plans.push(e.id);
        });
      } else {
        this.editedItem.plans = [];
      }
    },

    //
    applyAllMarketStatus() {
      if (this.applyAllMarket === "NOT_ALL") {
        this.editedItem.serviceMarkets = null;
        this.selectAllMarket = false;
      } else {
        this.editedItem.serviceMarkets = [];
      }
    },
    applyAllChannelStatus() {
      if (this.applyAllChannel === "NOT_ALL") {
        this.editedItem.serviceChannels = null;
        this.selectAllChannel = false;
      } else {
        this.editedItem.serviceChannels = [];
      }
    },
    clickSelectAllChannel() {
      if (this.selectAllChannel) {
        this.listOfChannels.forEach(e => {
          this.editedItem.serviceChannels.push(e.id);
        });
      } else {
        this.editedItem.serviceChannels = [];
      }
    },
    clickSelectAllMarket() {
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach(e => {
          this.editedItem.serviceMarkets.push(e.id);
        });
      } else {
        this.editedItem.serviceMarkets = [];
      }
    },
    toggleObject() {
      this.$nextTick(() => {
        if (this.likesAllPromotionParties) {
          this.editedItem.promotionParties = [];
        } else {
          // this.editedItem.rateParties = this.select.applyFor.slice();
          this.promotionParties.forEach(x => {
            this.editedItem.promotionParties.push(x.value);
          });
        }
      });
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>
<style lang="scss" scoped>
.mandatory-add-on {
  .icon-info {
    margin: 20px 0 0 5px !important
  }
}
.custom-tooltip {
  max-width: 250px !important;
  line-height: 1.5 !important;
}

#service-detail {
  .square {
    position: relative;
    flex-basis: 100%;
    box-sizing: border-box;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }
    & .square-content {
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .day-apply-in-week {
    .v-select__selections {
      input {
        display: none;
      }
    }
  }
  .add-not-apply-date {
    background-color: #cdcdcc;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    // outline: none;
    i {
      font-size: 18px;
    }
  }
  .include-tax {
    span {
      font-size: 13px;
      margin-top: 3px;
      padding-right: 10px;
    }
    .v-input {
      margin-top: 0;
      padding-top: 0;
      display: inline-block;
    }
  }
  .tbl-price {
    .form-control {
      min-width: 100%;
    }
  }
  span.icon {
    display: block;
    padding-top: 15px;
    width: 100px;
    text-align: center;
  }
  .price-day {
    margin: 5px 5px 0 5px !important;
  }
  .label-price {
    display: inline-block;
    float: left;
    font-size: 14px;
    padding-right: 10px;
    padding-top: 3px;
  }
  .vue-daterange-picker {
    width: 100%;
  }
  .btn-popup-special-days-price,
  .add-not-apply-date {
    background-color: #173d8f;
    color: #fff;
    i {
      color: #fff !important;
      font-size: 18px;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .special-service-desc {
    padding-left: 10px;
    color: red;
  }
  .priceSaturday {
    width: auto !important;
  }
}

.table-special-days-price .border-error#date-picker .v-input input {
  border-color: red;
}
</style>
